const chains = {
  eth: { chainId: 1, name: 'Ethereum', icon: require('../images/chain-eth.svg'), json: require(`../json/data-eth.json`), url: 'https://etherscan.io/address/' },
  bsc: { chainId: 56, name: 'BNB Chain', icon: require('../images/chain-bnb.svg'), json: require(`../json/data-bsc.json`), url: 'https://bscscan.com/address/' },
  // polygonscan: { chainId: 137, name: 'Polygon', icon: require('../images/chain-polygon.svg'), json: require(`../json/data-polygonscan.json`), url: 'https://polygonscan.com/address/' },
  ftmscan: { chainId: 250, name: 'Fantom', icon: require('../images/chain-ftmscan.svg'), json: require(`../json/data-ftmscan.json`), url: 'https://ftmscan.com/address/' },
}

export default chains
